import React, { useEffect, useState } from 'react';
import { CircularProgress, FormControlLabel, Box } from '@mui/material';
import axios from 'axios';
import { URL_BASE } from '../const/general';
import { BaseSwitch } from '../style/switch';
import { TypographyLeftMenu } from '../style/typography';

export default function SwichAnnounce(props) {
  const [loading, setLoading] = useState(false);

  const execAnnounce = async () => {
    try {
      const url = `${URL_BASE}api/announce`;
      const res = await axios.get(url);
      if (!res?.data?.status || res.data.status !== 'success' || !res?.data?.data) {
        return;
      }

      const byteString = atob(res.data.data);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }
      const audioBlob = new Blob([byteArray], { type: 'audio/wav' });
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audio.play();
      audio.onended = () => URL.revokeObjectURL(audioUrl);
    } catch (e) {
      console.error('announce API error:', e);
    }
  };

  // ローディング終了
  useEffect(() => {
    if (Object.values(props.isReady).every(v => v === true)
    ) {
      setLoading(false)
    }
  }, [props.isReady]);

  const handleSwitchChange = (event) => {
    // ローディング開始後にモード切り替え処理を開始
    requestAnimationFrame(() => {
      setTimeout(() => {
        props.setAnnounceSwitch(!props.announceSwitch);
      }, 0);
    });
  };

  // announceSwitchがONの間は即時+30分ごとに音声案内を実行
  useEffect(() => {
    let interval;
    if (props.announceSwitch) {
      execAnnounce();
      interval = setInterval(() => {
        execAnnounce();
      }, 1000 * 60 * 30);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [props.announceSwitch]);

  return (
    <Box display="flex" flexDirection="column" alignItems="left">
      <FormControlLabel
        control={
          <>
            <BaseSwitch
              checked={props.announceSwitch}
              onChange={handleSwitchChange}
            />
          </>
        }
        label={
          loading ?
            <CircularProgress
              size={10}
              color="inherit"
              disableShrink
              component="span"
              sx={{
                color: 'white',
                '& circle': {
                  stroke: 'white',
                },
              }}
            />
            :
            <TypographyLeftMenu
              sx={{
                fontSize: { xs: '0.75rem', sm: '0.75rem', md: 'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)' },
              }}
            >
              {/* トグルのON/OFFに応じて表示を切り替える */}
              {props.announceSwitch ? '音声案内を停止' : '音声案内を開始'}
            </TypographyLeftMenu>
        }
      />
    </Box>
  );
}